import React, { useEffect } from "react";
import { TileLayer, useMap } from "react-leaflet";
import { openDB } from "idb";

const TILE_DB_NAME = "rkMapsTileCache";
const TILE_STORE_NAME = "tiles";

const CachedTileLayer = ({ url, ...props }) => {
  const map = useMap();

  useEffect(() => {
    const initDB = async () => {
      const db = await openDB(TILE_DB_NAME, 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(TILE_STORE_NAME)) {
            db.createObjectStore(TILE_STORE_NAME);
          }
        },
      });
      return db;
    };

    const getTileFromCache = async (db, tileUrl) => {
      return await db.get(TILE_STORE_NAME, tileUrl);
    };

    const saveTileToCache = async (db, tileUrl, blob) => {
      await db.put(TILE_STORE_NAME, blob, tileUrl);
    };

    const interceptTileLoading = async (tileUrl) => {
      const db = await initDB();
      const cachedTile = await getTileFromCache(db, tileUrl);

      if (cachedTile) {
        return URL.createObjectURL(cachedTile);
      } else {
        try {
          const response = await fetch(tileUrl);
          const blob = await response.blob();
          saveTileToCache(db, tileUrl, blob);
          return URL.createObjectURL(blob);
        } catch (error) {
          console.error("Tile fetching error:", error);
          return tileUrl; // Fallback to the original URL in case of failure
        }
      }
    };

    // Override the tile loading behavior of Leaflet
    const tileLayer = map.eachLayer((layer) => {
      if (layer._url === url) {
        const originalCreateTile = layer.createTile;

        layer.createTile = (coords, done) => {
          const tile = document.createElement("img");
          tile.alt = "";
          tile.setAttribute("role", "presentation");

          const tileUrl = layer.getTileUrl(coords);

          interceptTileLoading(tileUrl)
            .then((cachedTileUrl) => {
              tile.src = cachedTileUrl;
              done(null, tile);
            })
            .catch((err) => {
              console.error(err);
              done(err, tile);
            });

          return tile;
        };
      }
    });
  }, [map, url]);

  return <TileLayer url={url} {...props} />;
};

export default CachedTileLayer;
